export default __webpack_public_path__ + "static/media/Arrow_Up_2.3fa64a7f.svg";